import {
  IMarketingCenterCreatePostDto,
  IMarketingCenterGetAsset,
  IMarketingCenterGetList,
  IMarketingCenterGetPost
} from '@/models/marketingCenter/post';
import APIService from '../api';

export default class MarketingCenterService extends APIService {
  listPosts(query?: string) {
    return this.get<IMarketingCenterGetList>(
      query || '/post?sort=post.createdAt:DESC'
    );
  }

  createPost(data: IMarketingCenterCreatePostDto) {
    return this.post('/post', data);
  }

  getPost(postId: string) {
    return this.get<IMarketingCenterGetPost>(`/post/${postId}`);
  }

  deletePost(postId: string) {
    return this.delete(`/post/${postId}`);
  }

  editPost(postId: string, data: IMarketingCenterCreatePostDto) {
    return this.put(`/post/${postId}`, data);
  }

  uploadAssets(postId: string, data: FormData) {
    return this.post<IMarketingCenterGetAsset[]>(
      `/post/${postId}/assets`,
      data
    );
  }

  downloadAssets(postId: string, query?: string) {
    return this.get(`/post/${postId}/download-assets${query || ''}`, {
      responseType: 'blob'
    });
  }
}
